export const baseImageUrl = '/assets/images/zoom'
export const platform = window.innerWidth <= 500 ? 'mobile' : 'desktop'
